import {Component, OnDestroy} from '@angular/core';
import {DateHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {Personenstand, PersonenstandEnum, PersonenstandEnumLabels} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'common-ui-personenstand',
  templateUrl: './personenstand.component.html'
})
export class PersonenstandComponent extends FormBaseComponent<Personenstand> implements OnDestroy {

  public personenstandEnum = PersonenstandEnumLabels;

  private personenStandSubscription: Subscription;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              private readonly translateService: TranslateService) {
    super(messageService);
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.personenStandSubscription.unsubscribe();
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      personenstand: [this.data.personenstand],
      gueltigSeit: [this.data.gueltigSeit, [
        this.validatorService.required(),
        this.validatorService.date(),
        this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.gueltigSeit),
          this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
      ]]
    });

    this.personenStandSubscription = this.form.get('personenstand').valueChanges.subscribe(value => {
      this.enableOrDisableGueltigSeit(value);
    });

    this.enableOrDisableGueltigSeit(this.data.personenstand);
  }

  private enableOrDisableGueltigSeit(value: PersonenstandEnum): void {
    this.messageService.clearMessages(`gueltigSeit${this.objectId}`);
    if (value) {
      this.form.get('gueltigSeit').enable();
    } else {
      this.data.gueltigSeit = null;
      this.form.get('gueltigSeit').disable();
    }
  }
}
